import type { ErrorRouteComponent } from '@tanstack/react-router'
import { BackgroundOrnaments } from '../decorative/background-ornaments'
import { LinkButton } from '../ui/button/link-button'
import { ErrorView } from '../ui/error-view'
import { Text } from '../ui/text'

export const UnexpectedError: ErrorRouteComponent = ({ error }) => {
  return (
    <>
      {/* TanStack router doesn't render Root component at all (makes sense because the React tree throws error), so BackgroundOrnament has to be specified again */}
      <BackgroundOrnaments />

      <main>
        <ErrorView
          title="Oops,"
          description={
            <div>
              <p>An unexpected error occurred, we’ve been informed.</p>

              <Text size={12} font="nbArchitekt" color="gold" block className="mt-8">
                Error:
              </Text>
              <div className="mt-2 bg-black text-white w-full overflow-x-auto border border-white/10 font-mono rounded-lg p-4">
                <pre className="text-xs">{error.message}</pre>
              </div>
            </div>
          }
          button={
            <LinkButton to="/" flex className="w-full">
              Back to Home
            </LinkButton>
          }
        />
      </main>
    </>
  )
}
